<template>
  <div class="particulars">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="planlobby_content">
        <div class="top_content">

          <div class="item">
            <span>代理简称</span>
            <div class="inpstyNew">
              {{ iteminfo.shortname }}
            </div>
          </div>
          <div class="item">
            <span>代理名称</span>
            <div class="inpstyNew">
              {{ iteminfo.name }}
            </div>
          </div>
          <div class="item">
            <span>代理电话</span>
            <div class="input">
              <m-super-ipt defaultInfo="请填写代理电话" v-model="iteminfo.telephone"></m-super-ipt>
            </div>
          </div>
          <div class="item">
            <span>代理地址</span>
            <div class="input">
              <p-input defaultInfo="请填写地址" v-model="iteminfo.address"></p-input>
            </div>
          </div>
          <div class="item">
            <span>管理员账号</span>
            <div class="input">
              <m-super-ipt readonly defaultInfo="请填写账号" v-model="iteminfo.telephone"></m-super-ipt>
            </div>
          </div>
          <!-- <div class="item">
          <span>道路运输许可</span>
          <div class="input">
            <m-super-ipt
              defaultInfo="请填写道路运输许可"
              v-model="iteminfo.transportlicencecode"
            ></m-super-ipt>
          </div>
        </div> -->
          <div class="item">
            <span>组织机构代码</span>
            <div class="input" v-if="iteminfo.orgcode">
              <p-input defaultInfo="请填写组织机构代码" v-model="iteminfo.orgcode"></p-input>
            </div>
            <div class="input" v-else>
              <p-input defaultInfo="请填写组织机构代码" v-model="iteminfo.businesslicenseCode"></p-input>
            </div>
          </div>
          <!-- <div class="item">
          <span>代理标识</span>
          <div class="input">
            <m-select
              :value="fleetType"
              @input="fleetTypevalue"
              :list="selectastrict"
              :isObj="true"
            ></m-select>
          </div>
        </div> -->
        </div>
        <div class="card">
          <div class="planlobby_content_box">
            <el-row>
              <el-col :span="6">
                <div class="card_box" v-if="iteminfo.businesslicense">
                  <div>营业执照：</div>
                  <div class="bottextarea">
                    <el-image lazy style="width: 100%; height: 100%" :src="iteminfo.businesslicense"
                      :preview-src-list="[iteminfo.businesslicense]">
                    </el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="card_box" v-if="iteminfo.transportlicence">
                  <div>道路运输许可证：</div>
                  <div class="bottextarea">
                    <el-image lazy style="width: 100%; height: 100%" :src="iteminfo.transportlicence"
                      :preview-src-list="[iteminfo.transportlicence]">
                    </el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="card_box" v-if="iteminfo.filingvoucher">
                  <div>备案凭证：</div>
                  <div class="bottextarea">
                    <el-image lazy style="width: 100%; height: 100%" :src="iteminfo.filingvoucher"
                      :preview-src-list="[iteminfo.filingvoucher]">
                    </el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="card_box" v-if="iteminfo.safeCertificate">
                  <div>安全资格证：</div>
                  <div class="bottextarea">
                    <el-image lazy style="width: 100%; height: 100%" :src="iteminfo.safeCertificate"
                      :preview-src-list="[iteminfo.safeCertificate]">
                    </el-image>
                  </div>
                </div>
              </el-col>
            </el-row>




            <el-row>
              <!-- <el-col :span="8">
              <div>
                <div>安全资格证:</div>
                <el-button type="primary" icon="el-icon-tickets" @click="yulan('safeCertificate')">点击预览</el-button>
              </div>
            </el-col> -->
              <el-col :span="8">
                <div v-if="iteminfo.letterOfCommit">
                  <div>承诺书:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('letterOfCommit')">点击预览</el-button>
                </div>
              </el-col>
              <el-col :span="8">
                <div v-if="iteminfo.jobTrainingRecords">
                  <div>岗前教育培训:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('jobTrainingRecords')">点击预览</el-button>
                </div>
              </el-col>
              <el-col :span="8">
                <div v-if="iteminfo.entryPersonInfo">
                  <div>进场人员信息:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('entryPersonInfo')">点击预览</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row>

              <el-col :span="8">
                <div v-if="iteminfo.entryVehicleInfo">
                  <div>进场机械车辆信息:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('entryVehicleInfo')">点击预览</el-button>
                </div>
              </el-col>
              <el-col :span="8">
                <div v-if="iteminfo.siteSafeProc">
                  <div>现场安全规程:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('siteSafeProc')">点击预览</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="button_btn">
            <button @click="retunrnpage">返回</button>
            <button style="background:#ff4900;color:#ffff" @click="isshow = true" v-if="usergt.username==='system'" >重置密码</button>
            <button style="background: #17B6A1; color: #fff" @click="editinfomsg" v-if="usergt.username==='system'">
              保存
            </button>
          </div>
        </div>
      </div>

      <pdialog :isshowdialog="isshow" @closedialog="editpassword"></pdialog>
    </div>
    <el-dialog title="PDF预览" :visible.sync="dialogVisible4" width="70%" center>
      <iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 600px"></iframe>
    </el-dialog>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import pdialog from "@/components/pdialog.vue";
import mSelect from "@/components/mSelect";
import mSuperIpt from "@/components/mSuperIpt.vue";
import {mapGetters} from 'vuex'
import pInput from "@/components/pInput.vue";
export default {
  name: 'particulars',
  data() {
    return {
      listitem: [{ name: "代理管理" }, { name: "企业列表", path: "/motorcade/newaddcheck" }, { name: "列表详情" }],
      timeout: null,
      isshow: false,
      iteminfo: {},
      fleetType: "",
      selectastrict: [],
      dialogVisible4: false,
      pdfSrc: ""
    };
  },
  computed:{
    ...mapGetters(["usergt"])
  },
  components: {
    mTitle,
    pdialog,
    mSelect,
    mSuperIpt,
    pInput
  },
  created() {
    this.getItemInfo(sessionStorage.getItem("infoid"));
  },
  mounted() { },
  methods: {
    async getItemInfo(id) {
      if (!id) return;
      const { data } = await this.$http(
        "api1",
        "/fleet/fleetfleetmessage/getFleetById",
        "get",
        { id: id }
      );
      if (!data.data) return console.log("请求失败");
      this.iteminfo = data.data;
      // this.getselectastrict();
    },
    async editpassword(val) {
      if (val == "affirm") {
        const { data } = await this.$http(
          "api1",
          "/fleet/fleetfleetmessage/resetPassword",
          "get",
          { id: this.iteminfo.id }
        );
        if (!data || data.msg != "success")
          return this.$message.error("重置密码失败");
        this.$message.success("修改成功");
        window.sessionStorage.removeItem("infoid");
        this.retunrnpage();
      } else {
        this.isshow = false;
      }
    },
    async getselectastrict() {
      const { data } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "代理标识",
      });
      if (data.code != 0) return console.log("获取代理标识失败");
      this.selectastrict = data.data;
      data.data.some((item) => {
        if (item.id == this.iteminfo.fleetType) {
          this.fleetType = item.val;
          return true;
        }
        return false;
      });
    },
    retunrnpage() {
      this.$router.push("/motorcade/motorcade")
    },
    fleetTypevalue(obj) {
      this.iteminfo.fleetType = obj.id;
      this.fleetType = obj.val;
    },
    editinfomsg() {

      this.iteminfo.username = this.iteminfo.telephone;
      let isok =
        !this.iteminfo.username ||
        !this.iteminfo.telephone
      if (isok) return this.$message.error("必填项不能为空");
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async (_) => {
        const { data } = await this.$http(
          "api1",
          "/fleet/fleetfleetmessage/updateFleetMessage",
          "post",
          this.iteminfo
        );
        if (!data || data.msg != "success")
          return this.$message.error("保存失败");
        this.$message.success("保存成功");
        window.sessionStorage.removeItem("infoid");
        this.retunrnpage();
      }, 300);
    },
    //预览
    yulan(txt) {
      let result = this.iteminfo[txt]
      if (result.includes('.pdf')) {
        this.dialogVisible4 = true
        this.pdfSrc = result
      } else {
        let url = 'http://view.officeapps.live.com/op/view.aspx?src=' + result
        window.open(url, '_target')
      }

    },
    retunrnpage() {
      this.$router.push("/motorcade/motorcade");
    },
  },
};
</script>
<style lang="scss" scoped>
.particulars {
  position: relative;
  height: 100%;

  .componentSty_content {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    background: #fff;
  }

  .planlobby_content {
    box-sizing: border-box;
    padding: 10px 0 0 0;
    height: 100%;
    background: #fff;

    .top_content {
      font-size: 90%;
      position: relative;
      box-sizing: border-box;
      height: 40%;

      .item {
        margin: 0 auto;
        width: 32%;
        height: 15%;
        text-align: right;
        font-size: 90%;
        margin-top: 5px;

        &::before {
          display: inline-block;
          content: "";
          height: 65%;
          vertical-align: middle;
        }

        .input,
        .inpstyNew {
          float: right;
          width: 72%;
          height: 65%;
          margin-left: 5%;
          background: #f3f4f5;
          text-align: left;
          border-radius: 2px;
          white-space: nowrap;
        }

        .inpstyNew {
          background: transparent;
        }

        .inpstyNew::before {
          content: "";
          display: inline-block;
          height: 100%;
          vertical-align: middle;
        }
      }
    }

    .card {
      box-sizing: border-box;
      height: 50%;

      .planlobby_content_box {
        // height: 80%;
        width: 60%;
        margin: 0 auto;

        .card_box {
          box-sizing: border-box;
          // display: inline-block;
          height: 50%;
          // width: 23%;
          margin-right: 1.3%;

          .bottextarea {
            width: 100%;
            height: 80%;
            background: #f3f4f5;
            background-size: 100% 100%;
            display: flex;
            justify-content: flex-end;
            // img {
            //   width: 100%;
            //   height: 100%;
            // }
          }
        }

      }

      .button_btn {
        margin: 0 auto;
        height: 30%;
        width: 40%;
        display: flex;
        justify-content: center;
        align-items: center;
        button {
          // margin-top: 5%;
          border: none;
          outline: none;
          width: 23%;
          margin-left: 10%;
          height: 50%;
          font-size: 80%;
          color: #17B6A1;
          background: #f3f4f5;
          border-radius: 5px;
        }

        button:first-child {
          margin: 0;
        }
      }
    }
  }

  .imgcontent {
    width: 100%;
    height: 600px;
    text-align: center;

    .img {
      width: auto;
      max-width: 100%;
      height: 100%;
    }
  }
}
</style>